import * as React from "react";
import {themeTokens} from "@octopusdeploy/design-system-tokens";
import { LockStatus } from "client/resources/instanceTaskLockResource";
import {ExclamationCircleIcon, ExclamationTriangleIcon} from "@octopusdeploy/design-system-icons";

export function getColorAndIconByLockStatus(status: LockStatus): {Color: string, Icon: JSX.Element} {
    if (status === LockStatus.Blocked) {
        return { Color: themeTokens.color.text.danger, Icon: <ExclamationCircleIcon size={24} color={themeTokens.color.icon.danger}/>};
    }
    else if (status === LockStatus.OverDue){
        return { Color: themeTokens.color.text.warning, Icon: <ExclamationTriangleIcon size={24} color={themeTokens.color.icon.warning}/>};
    }
    else{
        return { Color: themeTokens.color.text.primary, Icon: <></>};
    }
}
